import { render, staticRenderFns } from "./SearchLayout.vue?vue&type=template&id=f5648f68&scoped=true"
import script from "./SearchLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchLayout.vue?vue&type=style&index=0&id=f5648f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5648f68",
  null
  
)

export default component.exports